import { Card, CardContent } from "@/components/ui/card";
import { MapPin, CheckCircle, ListChecks, Clock } from "lucide-react";

const daysUntil = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return Math.max(0, Math.ceil((d.getTime() - Date.now()) / 86400000));
};

export const DashboardStats = ({ trackedCountries, user, calculateProgress }) => {
  const progress = trackedCountries.length && calculateProgress
    ? Math.round(trackedCountries.reduce((sum, c) => sum + calculateProgress(c.checklist), 0) / trackedCountries.length)
    : 0;
  const days = daysUntil(user?.core_access_expires);

  const stats = [
    { icon: <MapPin className="h-5 w-5 text-primary" />, bg: "bg-primary/10", value: trackedCountries.length, label: "Destinations" },
    { icon: <CheckCircle className="h-5 w-5 text-green-600" />, bg: "bg-green-100", value: trackedCountries.filter(c => c.status === 'active').length, label: "Active" },
    { icon: <ListChecks className="h-5 w-5 text-accent" />, bg: "bg-accent/10", value: `${progress}%`, label: "Checklist progress" },
    { icon: <Clock className="h-5 w-5 text-secondary-foreground" />, bg: "bg-secondary", value: days === null ? "—" : days, label: user?.cancel_at_period_end ? "Days of access left" : "Days to renewal" }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {stats.map((stat) => (
        <Card key={stat.label} className="border-border/50"><CardContent className="p-4 flex items-center gap-3"><div className={`w-10 h-10 rounded-lg ${stat.bg} flex items-center justify-center`}>{stat.icon}</div><div><p className="text-2xl font-bold">{stat.value}</p><p className="text-xs text-muted-foreground">{stat.label}</p></div></CardContent></Card>
      ))}
    </div>
  );
};
